import { render, staticRenderFns } from "./CampaingForm.vue?vue&type=template&id=69fb23df&"
import script from "./CampaingForm.vue?vue&type=script&lang=js&"
export * from "./CampaingForm.vue?vue&type=script&lang=js&"
import style0 from "./CampaingForm.vue?vue&type=style&index=0&id=69fb23df&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QSpace,QBtn,QForm,QInput,QChip,QSelect,QBtnDropdown,QIcon,QOptionGroup,QTable,QTd,QItem,QItemSection,QCheckbox,QFile,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QCardSection,QSpace,QBtn,QForm,QInput,QChip,QSelect,QBtnDropdown,QIcon,QOptionGroup,QTable,QTd,QItem,QItemSection,QCheckbox,QFile,QCardActions})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
